import script from "./ProductLearnModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductLearnModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductLearnModal.vue?vue&type=style&index=0&id=0abf5468&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0abf5468"]])

export default __exports__